import React from "react";
const starter = (
  <div>
    В тариф также входят следующие модули:
    <br />
    - Автоматическое форматирование документов перевозки (договор услуги,
    заказ-наряд, путевой лист и т.д.);
    <br />
    - Отчет по заказу;
    <br />
    - База свободных заявок;
    <br />
    - Дистанционное заключение договоров;
    <br />
    - Формирование документов для организованной перевозки группы детей (включая
    уведомление в ГИБДД);
    <br />
    - Доплаты по заказу.
    <br />
    <br />
    Также доступны дополнительные услуги:
    <br />
    - Каждый водитель сверх лимита: 250 руб./месяц;
    <br />- Каждое ТС сверх лимита: 2 500 руб./месяц;
  </div>
);
const standart = (
  <div>
    В тариф также входят следующие модули:
    <br />
    - Автоматическое форматирование документов перевозки (договор услуги,
    заказ-наряд, путевой лист и т.д.);
    <br />
    - Отчет по заказу;
    <br />
    - База свободных заявок;
    <br />
    - Дистанционное заключение договоров;
    <br />
    - Формирование документов для организованной перевозки группы детей (включая
    уведомление в ГИБДД);
    <br />
    - Доплаты по заказу.
    <br />
    <br />
    Также доступны дополнительные услуги:
    <br />
    - Каждый водитель сверх лимита: 100 руб./месяц;
    <br />
    - Каждый сотрудник сверх лимита: 500 руб./месяц;
    <br />
    - Каждое ТС сверх лимита: 1 000 руб./месяц;
    <br />- Каждый дополнительный исполнитель сверх лимита: 1 000 руб./месяц
    (максимум – 2 доп. исполнителей){" "}
  </div>
);

const advanced = (
  <div>
    В тариф также входят следующие модули:
    <br />
    - Автоматическое форматирование документов перевозки (договор услуги,
    заказ-наряд, путевой лист и т.д.);
    <br />
    - Отчет по заказу;
    <br />
    - База свободных заявок;
    <br />
    - Дистанционное заключение договоров;
    <br />
    - Формирование документов для организованной перевозки группы детей (включая
    уведомление в ГИБДД);
    <br />
    - Доплаты по заказу.
    <br />
    <br />
    Также доступны дополнительные услуги:
    <br />
    - Каждый водитель сверх лимита: 100 руб./месяц;
    <br />
    - Каждый сотрудник сверх лимита: 500 руб./месяц;
    <br />
    - Каждое ТС сверх лимита: 1 000 руб./месяц;
    <br />- Каждый дополнительный исполнитель сверх лимита: 1 000 руб./месяц
    (максимум – 3 доп. исполнителей)
  </div>
);

const maximum = (
  <div>
    В тариф также входят следующие модули:
    <br />
    - Автоматическое форматирование документов перевозки (договор услуги,
    заказ-наряд, путевой лист и т.д.);
    <br />
    - Отчет по заказу;
    <br />
    - База свободных заявок;
    <br />
    - Дистанционное заключение договоров;
    <br />
    - Формирование документов для организованной перевозки группы детей (включая
    уведомление в ГИБДД);
    <br />
    - Доплаты по заказу.
    <br />
    <br />
    Также доступны дополнительные услуги:
    <br />
    - Каждый водитель сверх лимита: 100 руб./месяц;
    <br />
    - Каждый сотрудник сверх лимита: 500 руб./месяц;
    <br />- Каждый дополнительный исполнитель сверх лимита: 1 000 руб./месяц
    (максимум – 4 доп. исполнителей)
  </div>
);

export const TariffContent = value => {
  switch (value.title) {
    case "Стартовый":
      return starter;
    case "Стандартный":
      return standart;
    case "Продвинутый":
      return advanced;
    case "Максимальный":
      return maximum;
    default:
      return null;
  }
};
